(function($) {
  function ImageSpinnerManager(selector, options) {
    this.$container = $(selector);
    this.$element = this.$container.find('.ImageSpinnerManager-spinner');
    this.$switches = this.$container.find('.ImageSpinnerManager-switch');
    this.$descriptions = this.$container.find('.ImageSpinnerManager-description');
    this.$buyButton = this.$container.find('.ImageSpinnerManager-buyNow');

    this.images = options.images;
    this.addListeners();
    this.init();
  };

  ImageSpinnerManager.prototype.addListeners = function() {
    this.$switches.on('click', this.changeSpinner.bind(this));
    this.$buyButton.on('click', this.forceLink.bind(this));
  };

  ImageSpinnerManager.prototype.forceLink = function(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.href = this.$buyButton.attr('href');
  };

  ImageSpinnerManager.prototype.init = function() {
    var $selected = this.$switches.filter('.is-selected')
    var selected = $selected.data('item');
    var images = this.images[selected];
    this.$element.imageSpinner({
      images: images
    });
    this.$descriptions.filter(function(i, item) {
      return $(item).data('item') == selected;
    }).addClass('is-selected');
    this.$buyButton.attr('href', $selected.data('url'));
  };

  ImageSpinnerManager.prototype.changeSpinner = function(event) {
    var $el = $(event.currentTarget);
    this.$switches.removeClass('is-selected');
    this.$descriptions.removeClass('is-selected')
    $el.addClass('is-selected');
    var selected = $el.data('item');
    var images = this.images[selected];
    this.$element.imageSpinner('setImages', images);
    this.$descriptions.filter(function(i, item) {
      return $(item).data('item') == selected;
    }).addClass('is-selected');
    this.$buyButton.attr('href', $el.data('url'));
  };

  window.ImageSpinnerManager = ImageSpinnerManager;
})(jQuery);